export default __webpack_public_path__ + "static/media/girl-2.d1111209.png";